import o from "./_virtual/Batch.mjs";
import r from "./_virtual/ClientBuilder.mjs";
import t from "./_virtual/buildClients.mjs";
import i from "./_virtual/SharedCredentials.mjs";
import m from "./_virtual/StaticCredentials.mjs";
import u from "./_virtual/Errors.mjs";
import e from "./_virtual/Lookup.mjs";
import s from "./_virtual/Candidate.mjs";
import a from "./_virtual/Lookup2.mjs";
import p from "./_virtual/Result.mjs";
import l from "./_virtual/Lookup3.mjs";
import n from "./_virtual/Suggestion.mjs";
import v from "./_virtual/Lookup4.mjs";
import d from "./_virtual/Result2.mjs";
import f from "./_virtual/Lookup5.mjs";
import j from "./_virtual/Candidate2.mjs";
import _ from "./_virtual/Lookup6.mjs";
import k from "./_virtual/Lookup7.mjs";
import L from "./_virtual/Suggestion2.mjs";
import C from "./_virtual/Lookup8.mjs";
import c from "./_virtual/Response.mjs";
const S = {
    Batch: o,
    ClientBuilder: r,
    buildClient: t,
    SharedCredentials: i,
    StaticCredentials: m,
    Errors: u
  },
  g = {
    Lookup: e,
    Candidate: s
  },
  R = {
    Lookup: a,
    Result: p
  },
  h = {
    Lookup: l,
    Suggestion: n
  },
  B = {
    Lookup: v,
    Result: d
  },
  E = {
    Lookup: f,
    Candidate: j
  },
  A = {
    Lookup: _
  },
  b = {
    Lookup: k,
    Suggestion: L
  },
  x = {
    Lookup: C,
    Response: c
  };
var G = {
  core: S,
  usStreet: g,
  usZipcode: R,
  usAutocompletePro: h,
  usExtract: B,
  internationalStreet: E,
  usReverseGeo: A,
  internationalAddressAutocomplete: b,
  usEnrichment: x
};
export { S as core, G as default, b as internationalAddressAutocomplete, E as internationalStreet, h as usAutocompletePro, x as usEnrichment, B as usExtract, A as usReverseGeo, g as usStreet, R as usZipcode };